import { dayjs } from '@tunasong/models'
import type { MaterialColor } from '@tunasong/plugin-lib'
import { HBox, Typography, VBox } from '@tunasong/ui-lib'
import cn from 'classnames'
import React from 'react'
import type { FC, Ref } from 'react'
import styles from './chat-item.module.css'

export interface ChatItemProps {
  name: string
  timestamp: string
  UserIcon: FC

  color?: MaterialColor

  children: React.ReactNode
  actions?: React.ReactNode

  highlight?: boolean
  type: 'message' | 'response' | 'assistant'

  ref: Ref<unknown>
}

export const ChatItem: FC<ChatItemProps> = props => {
  const { name, actions, UserIcon, type, highlight, timestamp, children, ref } = props

  const iconBox = (
    <div className={styles.iconBox}>
      <UserIcon />
    </div>
  )
  const contentBox = <div className={styles.contentBox}>{children}</div>

  const layout =
    type === 'message' ? (
      <>
        {iconBox}
        {contentBox}
        {actions}
      </>
    ) : (
      <>
        {actions}
        {contentBox}
        {iconBox}
      </>
    )
  const position = type === 'message' ? 'left' : 'right'
  const flexPosition = type === 'message' ? 'flex-start' : 'flex-end'
  const textStyle = { marginLeft: position === 'left' ? 48 : 0, marginRight: position === 'right' ? 48 : 0 }

  return (
    <VBox style={{ alignItems: flexPosition }} ref={ref}>
      <Typography className={styles.name} style={{ ...textStyle }} variant="body2">
        {name}
      </Typography>
      <HBox
        className={cn(styles.messageRow, highlight && styles['messageRow--highlight'])}
        style={{ justifyContent: flexPosition }}
      >
        {layout}
      </HBox>
      <div className={cn(position === 'left' ? styles.timestampLeft : styles.timestampRight)}>
        <Typography color="var(--tuna-palette-primary-dark)" variant="caption">
          {dayjs(timestamp).fromNow()}
        </Typography>
      </div>
    </VBox>
  )
}

export default ChatItem
